import React, { useCallback, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useKeyPress } from '@24i/player-utils-react';
import { StyledIcon as PlayerIcon } from '../../../Icons';
import { Button } from '../../../Button/styled';
const volumeIconsMap = {
    default: {
        mute: 'onDark-control_volume_off',
        low: 'onDark-control_volume_mute',
        medium: 'onDark-control_volume_down',
        high: 'onDark-control_volume_up',
    },
    podcast: {
        mute: 'onPrimary-control_volumeMute',
        low: 'onPrimary-control_volumeLow',
        medium: 'onPrimary-control_volumeMid',
        high: 'onPrimary-control_volumeHigh',
    },
};
const RenderDefaultIcon = (volume, muted, disabled, backgroundColor, styles, variant) => {
    const getIcon = () => {
        const iconVariant = variant === 'podcast' ? 'podcast' : 'default';
        const relevantIcons = volumeIconsMap[iconVariant];
        if (muted) {
            return relevantIcons.mute;
        }
        if (volume < 1 / 3) {
            return relevantIcons.low;
        }
        if (volume < 2 / 3) {
            return relevantIcons.medium;
        }
        return relevantIcons.high;
    };
    return (React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.icon), { opacity: disabled ? 0.4 : 1 }), name: getIcon(), "data-test": "VolumeButton-Icon", className: "VolumeButton-Icon", backgroundColor }));
};
export const VolumeButton = ({ playerInstance, backgroundColor = 'transparent', className = '', show, hide, muted, volume, customIcon = RenderDefaultIcon, disabled, styles = {
    button: null,
    icon: null,
}, variant, }) => {
    const ARROW_STEP = 0.05;
    const upPress = useKeyPress('ArrowUp', true);
    const downPress = useKeyPress('ArrowDown', true);
    const MPress = useKeyPress('M', true);
    const mPress = useKeyPress('m', true);
    useEffect(() => {
        if (!disabled && upPress) {
            const currentVolume = playerInstance.volume;
            playerInstance.volume = Math.min(1, currentVolume + ARROW_STEP);
        }
    }, [upPress]);
    useEffect(() => {
        if (!disabled && downPress) {
            const currentVolume = playerInstance.volume;
            playerInstance.volume = Math.max(0, currentVolume - ARROW_STEP);
        }
    }, [downPress]);
    const onClick = useCallback((event) => {
        if (disabled)
            return;
        playerInstance.muted = !playerInstance.muted;
        if (isMobile) {
            show();
        }
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [playerInstance]);
    useEffect(() => {
        if (!mPress && !MPress)
            return;
        onClick(null);
    }, [MPress, mPress]);
    return (React.createElement(Button, { backgroundColor, disabled, onClick, style: styles.button, "data-test": "VolumeButton", testID: "volume_button", className: `VolumeButton ${className}`, onMouseEnter: show, onPress: show, onMouseLeave: hide, onBlur: hide }, customIcon(volume, muted, disabled, backgroundColor, styles, variant)));
};
//# sourceMappingURL=index.js.map